import {gridFilteredDescendantCountLookupSelector, useGridApiContext, useGridSelector} from "@mui/x-data-grid-pro";
import {Button, Typography} from "@mui/material";
import React from "react";
import css_pages from "../pages/css/Pages.module.scss";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import css_link from "./Common/css/Link.module.scss";

export function CustomGridTreeDataGroupingCell(props) {
    const { id, field, rowNode } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );

    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleClick = (event) => {
        if (rowNode.type !== 'group') {
            return;
        }

        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation();
    };

    let link = "";
    if (props.rows && props.rows.length > 0) {
        if (process.env.REACT_APP_ENLIL_ENV === "prod") {
            link = "https://enlil.io/document_revision/" + props.rows[props.row.id].get("DocumentUSID") + "/version/" + props.rows[props.row.id].get("DocumentRevisionUSID")
        } else {
            link = "https://" + process.env.REACT_APP_ENLIL_ENV + ".enlil.io/document_revision/" + props.rows[props.row.id].get("DocumentUSID") + "/version/" + props.rows[props.row.id].get("DocumentRevisionUSID")
        }
    }
    return (
        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
            <div style={{marginTop: "0px", marginBottom: "auto", marginLeft: rowNode.depth * 4 * 6}}>
                {filteredDescendantCount > 0 ? (
                    <Button className={css_pages.DropdownButton} style={{marginTop: "10px"}} onClick={(event) => handleClick(event)} startIcon={rowNode.childrenExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}>
                        <Typography style={{color: "#000000", fontWeight: 500, fontSize: "14px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{props.value}</a></Typography>
                    </Button>
                ) : (
                    <Typography style={{color: "#000000", fontWeight: 400, fontSize: "14px", marginTop: "10px"}}><a className={css_link.link} href={link} rel="noreferrer" target="_blank">{props.value}</a></Typography>
                )}
            </div>
        </div>
    );
}


